import { render, staticRenderFns } from "./currency-input.vue?vue&type=template&id=5ad3c319&"
import script from "./currency-input.vue?vue&type=script&lang=js&"
export * from "./currency-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/galexp/development/web/educraft-vue-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ad3c319')) {
      api.createRecord('5ad3c319', component.options)
    } else {
      api.reload('5ad3c319', component.options)
    }
    module.hot.accept("./currency-input.vue?vue&type=template&id=5ad3c319&", function () {
      api.rerender('5ad3c319', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/currency-input.vue"
export default component.exports